export function HowItWorks() {
  return (
    <section id="how-it-works" className="how-it-works" aria-labelledby="how-it-works-heading">
      <h2 id="how-it-works-heading">Cómo funciona</h2>
      <div className="how-it-works__grid">
        <div>
          <h3>Contrato</h3>
          <p>
            La entrada y la salida siguen{" "}
            <a href="https://github.com/Aredex/mcp-app-ui-kit/blob/main/contracts/input.schema.json">
              <code>contracts/input.schema.json</code>
            </a>{" "}
            y{" "}
            <a href="https://github.com/Aredex/mcp-app-ui-kit/blob/main/contracts/output.schema.json">
              <code>contracts/output.schema.json</code>
            </a>
            . Se validan con <code>ajv</code> en cada ejecución, en el navegador.
          </p>
        </div>
        <div>
          <h3>Arquitectura</h3>
          <p>
            Sin backend propio: el motor de reglas es una función pura en TypeScript
            (<code>src/domain/engine.ts</code>) que se ejecuta dentro de un Web Worker
            cancelable. Nada sale del dispositivo en modo determinista.
          </p>
        </div>
        <div>
          <h3>Límites</h3>
          <ul>
            <li>Payload máximo 20 KB y profundidad máxima 6 niveles.</li>
            <li>Hasta 1000 hallazgos visibles por ejecución.</li>
            <li>Exportación máxima 5 MB, sin el payload original.</li>
            <li>Cero solicitudes de red durante el modo determinista.</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
